// extracted by mini-css-extract-plugin
export var closeButton = "_3i-3";
export var header = "_3i-0";
export var link = "_3i-1";
export var retryButton = "_3i-2";